import { Container } from 'inversify-props';
import setupUserPasswordModule from './password/setup';
import setupCancelAccountModule from './cancel-account/setup';
import setupCustomerAddress from './customer-address/setup';
import setupCustomerBankAccount from './customer-bank-account/setup';

export default function setupUserModule(container: Container) {
  setupUserPasswordModule(container);
  setupCancelAccountModule(container);
  setupCustomerAddress(container);
  setupCustomerBankAccount(container);
}
